// extracted by mini-css-extract-plugin
module.exports = {"titles":"BannerTitles_titles__qsw2u","title":"BannerTitles_title__B_zJd","subtitlesGroup":"BannerTitles_subtitlesGroup__mgdmF","subtitle":"BannerTitles_subtitle__SEXNI"};